/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Svr_BackInputs */

const en_svr_back = /** @type {(inputs: Svr_BackInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Back to ticket`)
};

const ja_svr_back = /** @type {(inputs: Svr_BackInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`チケットに戻る`)
};

const fr_svr_back = /** @type {(inputs: Svr_BackInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Retour au ticket`)
};

const de_svr_back = /** @type {(inputs: Svr_BackInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zurück zum Ticket`)
};

/**
* | output |
* | --- |
* | "Back to ticket" |
*
* @param {Svr_BackInputs} inputs
* @param {{ locale?: "en" | "ja" | "fr" | "de" }} options
* @returns {LocalizedString}
*/
export const svr_back = /** @type {((inputs?: Svr_BackInputs, options?: { locale?: "en" | "ja" | "fr" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Svr_BackInputs, { locale?: "en" | "ja" | "fr" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_svr_back(inputs)
	if (locale === "ja") return ja_svr_back(inputs)
	if (locale === "fr") return fr_svr_back(inputs)
	return de_svr_back(inputs)
});